import type { TopologyPlugin } from "../types";
import type { Rng } from "../../sim/rng";

function randomTargets(n: number, rng: Rng, forbidSelf: boolean): Int32Array {
  const t = new Int32Array(n);
  for (let i = 0; i < n; i++) {
    let j = rng.int(n);
    if (forbidSelf && j === i) j = (i + 1) % n;
    t[i] = j;
  }
  if (forbidSelf) {
    for (let i = 0; i < n; i++) {
      if (t[i] === i) t[i] = (i + 1) % n;
    }
  }
  return t;
}

export const randomTopology: TopologyPlugin = {
  id: "random",
  label: "Random",
  tier: "basic",
  description: "Independent random friend and enemy pointers",
  init(params, rng) {
    const n = params.n;
    return {
      friends: randomTargets(n, rng, params.forbidSelfLinks),
      enemies: randomTargets(n, rng, params.forbidSelfLinks),
    };
  },
};

export const ringChainTopology: TopologyPlugin = {
  id: "ring_chain",
  label: "Ring chain",
  tier: "basic",
  description: "Friends cycle with ring_stride; enemies random fixed",
  init(params, rng) {
    const n = params.n;
    const stride = Math.max(params.ringStride, 1);
    const friends = new Int32Array(n);
    for (let i = 0; i < n; i++) friends[i] = (i + stride) % n;
    return {
      friends,
      enemies: randomTargets(n, rng, params.forbidSelfLinks),
    };
  },
};

/** Alias of ring_chain with explicit multi-ring semantics (same stride rule). */
export const multiRingTopology: TopologyPlugin = {
  id: "multi_ring",
  label: "Multi-ring",
  tier: "advanced",
  description: "Interleaved cycles via ring_stride (Kirma)",
  init(params, rng) {
    return ringChainTopology.init(params, rng);
  },
};
